import { render } from "./privacypage.vue?vue&type=template&id=2d865c3c&scoped=true"
import script from "./privacypage.vue?vue&type=script&lang=js"
export * from "./privacypage.vue?vue&type=script&lang=js"

import "./privacypage.vue?vue&type=style&index=0&id=2d865c3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d865c3c"]])

export default __exports__